import { render, staticRenderFns } from "./WetBulbGlobeTemperature.vue?vue&type=template&id=df473134&scoped=true&"
import script from "./WetBulbGlobeTemperature.vue?vue&type=script&lang=ts&"
export * from "./WetBulbGlobeTemperature.vue?vue&type=script&lang=ts&"
import style0 from "./WetBulbGlobeTemperature.vue?vue&type=style&index=0&id=df473134&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df473134",
  null
  
)

export default component.exports